import { ComponentType } from '@angular/cdk/portal';
import {
	AfterViewInit,
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	inject,
	ViewChild,
	ViewContainerRef,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { EntitySelectedTypes, EntityDialogComponents } from '@app/domain/types';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'component-overlay-dialog',
	imports: [MatDialogClose, NgxTolgeeModule, MatButtonModule],
	templateUrl: './component-overlay-dialog.component.html',
	styleUrls: ['./component-overlay-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComponentOverlayDialogComponent implements AfterViewInit {
	private readonly dialogData = inject(MAT_DIALOG_DATA) as {
		component: ComponentType<EntityDialogComponents>;
		title?: string;
		outputEventName?: string;
	};

	@ViewChild('componentOutlet', { read: ViewContainerRef })
	componentOutlet!: ViewContainerRef;

	component: ComponentType<EntityDialogComponents> = this.dialogData.component;
	title = this.dialogData?.title;
	outputEvent = this.dialogData?.outputEventName;
	selectedData: EntitySelectedTypes[] = [];

	ngAfterViewInit() {
		const eventEmitter: EventEmitter<EntitySelectedTypes[]> =
			this.componentOutlet.createComponent(this.component).instance[
				this.outputEvent
			] as EventEmitter<EntitySelectedTypes[]>;

		if (eventEmitter) {
			eventEmitter.subscribe((value: EntitySelectedTypes[]) => {
				this.selectedData = value;
			});
		}
	}
}
